import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';

import { formatDateTime } from '../../../utils';

/**
 * Modales de soporte para fotos (Lightbox a pantalla completa y confirmación de eliminación)
 */
const TagPhotoModals = ({
  lightboxPhoto,
  onCloseLightbox,
  photoToDelete,
  isDeletingPhoto,
  onCloseDeletePhoto,
  onConfirmDeletePhoto,
  isDark
}) => {
  return (
    <>
      {/* LIGHTBOX MODAL */}
      {lightboxPhoto && (
        <div
          className="modal d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1080 }}
          onClick={onCloseLightbox}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center h-100 p-3"
            style={{ position: 'relative' }}
          >
            <button
              type="button"
              className="btn text-white position-absolute shadow-none"
              style={{ top: '15px', right: '20px', fontSize: '1.5rem', zIndex: 1090 }}
              onClick={onCloseLightbox}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>

            <img
              src={lightboxPhoto.vUrlFoto}
              alt={lightboxPhoto.vNombreArchivo || 'Evidencia'}
              style={{
                maxWidth: '90vw',
                maxHeight: '80vh',
                objectFit: 'contain',
                borderRadius: '8px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.5)'
              }}
              onClick={e => e.stopPropagation()}
            />

            <div
              className="mt-3 text-center text-white"
              style={{ maxWidth: '600px' }}
              onClick={e => e.stopPropagation()}
            >
              <div className="fw-semibold">{lightboxPhoto.vNombreArchivo}</div>
              {lightboxPhoto.vDescripcion && (
                <div className="small text-light opacity-75 mt-1">{lightboxPhoto.vDescripcion}</div>
              )}
              <div className="small opacity-50 mt-1" style={{ fontSize: '0.72rem' }}>
                {lightboxPhoto.vCreatedUser ? `Subido por ${lightboxPhoto.vCreatedUser} - ` : ''}
                {formatDateTime(lightboxPhoto.dCreatedDate)}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL ELIMINAR FOTO */}
      {photoToDelete && (
        <div
          className="modal d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1090 }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px' }}>
            <div
              className="modal-content border shadow-lg"
              style={{
                backgroundColor: isDark ? '#182635' : '#ffffff',
                borderColor: isDark ? '#233142' : '#cbd5e1'
              }}
            >
              <div className="modal-body px-4 py-4 text-center">
                <div
                  className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3 text-danger"
                  style={{
                    width: '46px',
                    height: '46px',
                    backgroundColor: isDark ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2'
                  }}
                >
                  <FontAwesomeIcon icon={faTrash} style={{ fontSize: '1.1rem' }} />
                </div>
                <h6 className="fw-bold mb-2" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
                  ¿Eliminar Foto?
                </h6>
                <p className="small text-muted mb-3" style={{ fontSize: '0.84rem' }}>
                  ¿Estás seguro de que deseas eliminar la foto{' '}
                  <strong>"{photoToDelete.vNombreArchivo || 'esta foto'}"</strong> de la incidencia?
                </p>

                <div className="d-flex align-items-center justify-content-center gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary rounded-pill px-3 shadow-none"
                    onClick={onCloseDeletePhoto}
                    disabled={isDeletingPhoto}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-danger rounded-pill px-4 shadow-none fw-semibold"
                    onClick={onConfirmDeletePhoto}
                    disabled={isDeletingPhoto}
                  >
                    {isDeletingPhoto ? 'Eliminando...' : 'Sí, Eliminar'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TagPhotoModals;
